/* RESPONSIBLE TEAM: team-ai-insights */

import { get } from 'embercom/lib/ajax';

export interface Topic {
  name: string;
  description: string | null;
  subtopics: {
    [subtopicName: string]: string[];
  };
}

export interface TopicTaxonomy {
  [key: string]: Topic;
}

interface SerializedSubtopic {
  topic_name: string;
  topic_description: string;
  subtopic_name: string;
  _subtopic_representative_docs: string[];
}

async function fetchTopicsTaxonomy(appId: any, signal?: AbortSignal) {
  let response = (await get(
    '/ember/ai_insights/topics',
    {
      app_id: appId,
    },
    { signal },
  )) as { topics: SerializedSubtopic[] };

  let topics = {} as TopicTaxonomy;
  for (let entry of response.topics) {
    let topic = topics[entry.topic_name] || {
      name: entry.topic_name,
      description: entry.topic_description,
      subtopics: {},
    };

    // Add subtopic representative docs if available
    if (entry._subtopic_representative_docs) {
      topic.subtopics[entry.subtopic_name] = entry._subtopic_representative_docs;
    }

    topics[topic.name] = topic;
  }
  return topics;
}

export { fetchTopicsTaxonomy };
